import React from 'react';
import { useLocation } from 'react-router-dom';
import { RESULT_TYPES } from '../constants/config';
import ResultPage from '../components/ResultPage';
import useScrollToTop from '../hooks/useScrollToTop';

const Success = () => {
  const location = useLocation();
  const bookingDetails = location.state?.bookingDetails;

  useScrollToTop();

  return (
    <ResultPage
      type={RESULT_TYPES.success}
      title="Booking Enquiry Sent Successfully!"
      message="Thank you for your interest in Travel Mhor! We've received your booking enquiry and will contact you within 24 hours to confirm your tour details and answer any questions."
      bookingDetails={bookingDetails}
    />
  );
};

export default Success;
